import Vue, { VueConstructor } from "vue";
type RequireContext = ReturnType<typeof require.context>;

interface Module<T, C> {
  default: C;
  selector: (item: T) => boolean;
}
export function getContextModules<T, C = VueConstructor<Vue>>(context: RequireContext) {
  return context.keys().reduce<Module<T, C>[]>((out, key) => {
    const module = context(key);
    out.push(module);
    return out;
  }, []);
}

export function getComponent<T, C>(modules: Module<T, C>[], item: T, defaultComponent: C): C {
  const module = modules.find(m => m.selector(item)) || { default: defaultComponent };
  return module.default;
}
